export enum PropensityEngineTypes {
    churn = 'churn',
    purchase = 'purchase',
    subscribe = 'subscribe',
}
